import {
  Settings,
  Archive,
  Trash2,
  Mail,
  BellOff,
  Ban,
  Eraser,
  Pin,
} from "lucide-react";
import type { MenuAction } from "../../../types/index"

interface DropdownMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onAction: (action: MenuAction) => void;
  isPinned?: boolean;
}

export function DropdownMenu({
  isOpen,
  onClose,
  onAction,
  isPinned,
}: DropdownMenuProps) {
  if (!isOpen) return null;

  const menuItems = [
    {
      icon: <Settings className="w-4 h-4" />,
      label: "User profile settings",
      action: { type: "settings" } as MenuAction, // Ensure this matches the MenuAction type
    },
    {
      icon: <Archive className="w-4 h-4" />,
      label: "Archive chat",
      action: { type: "archive" } as MenuAction,
    },
    {
      icon: <Trash2 className="w-4 h-4" />,
      label: "Delete conversation",
      action: { type: "delete" } as MenuAction,
    },
    {
      icon: <Mail className="w-4 h-4" />,
      label: "Mark as unread",
      action: { type: "mark-unread" } as MenuAction,
    },
    {
      icon: <BellOff className="w-4 h-4" />,
      label: "Mute notifications",
      action: { type: "mute" } as MenuAction,
    },
    {
      icon: <Ban className="w-4 h-4" />,
      label: "Block contact",
      action: { type: "block" } as MenuAction,
    },
    {
      icon: <Eraser className="w-4 h-4" />,
      label: "Clear chat history",
      action: { type: "clear" } as MenuAction,
    },
    {
      icon: <Pin className="w-4 h-4" />,
      label: isPinned ? "Unpin conversation" : "Pin conversation",
      action: { type: "pin" } as MenuAction,
    },
  ];

  const handleClick = (action: MenuAction) => {
    onAction(action);
    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 z-30" onClick={onClose} />
      <div className="absolute right-0 top-full mt-1 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-40">
        <div className="py-1" role="menu">
          {menuItems.map((item) => (
            <button
              key={item.action.type}
              onClick={() => handleClick(item.action)}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center space-x-2"
              role="menuitem"
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
